<!-- 
Roles listing page.
-->
<template>
  <div>
    <our-heading 
      :breadcrumbs="breadcrumbs"
      title="Roles & permissions"
      user-guide-topic="administration-roles-and-permissions"
    />
    <our-actions-bar 
      :actions="actions" 
      xs-breakpoint
      @create="showCreateDialog=true" 
      @matrix="showPermissionMatrix=true"
    />
    <role-listing ref="listing" @changed="$refs.listing.refresh()"/>
    <role-edit-dialog v-model="showCreateDialog" create @changed="openNewRole"/>
    <role-permission-matrix v-model="showPermissionMatrix"/>
  </div>
</template>

<script>
import * as claim from "@/store/claim-types";
import RoleListing from "@/components/roles/RoleListing.vue";
import RoleEditDialog from "@/components/roles/RoleEditDialog.vue";
import RolePermissionMatrix from "@/components/roles/RolePermissionMatrix.vue";

export default {
  name: "Roles",
  components: { RoleListing, RoleEditDialog, RolePermissionMatrix },
  data() {
    return {
      showCreateDialog: false,
      showPermissionMatrix: false,
      breadcrumbs: [{ text: "Roles & permissions" }]
    };
  },
  computed: {
    actions() {
      const actions = [];
      if (this.canEdit) {
        actions.push({ text: "Add role", emit: "create", icon: "add_circle_outline" });
      }
      actions.push({ text: "Permission matrix", emit: "matrix", icon: "security" });
      return actions;
    },
    canEdit() {
      return this.$store.getters.claims.includes(claim.ROLES_EDIT);
    }
  },
  methods: {
    openNewRole(role) {
      this.$router.push(`/roles/${role.id}`);
    }
  }
};
</script>
